import React, { useMemo, useState } from 'react'
import styled from 'styled-components'
import { Currency, Trade, TradeType } from '@nominex/nomiswap-sdk'
import { SlButton } from '@shoelace-style/shoelace/dist/react'
import { useTranslation } from 'contexts/Localization'
import { computeTradePriceBreakdown, warningSeverity } from 'utils/prices'
import { AutoColumn, AutoRow, RowBetween } from 'components/Layout'
import { CashbackPoolResponse } from 'restApi/openapi/models'
import { AdvancedSwapDetails } from './AdvancedSwapDetails'
import TradePrice from './TradePrice'

const SwapModalFooterContainer = styled(AutoColumn)`
  margin-top: 24px;
  padding: 16px;
  border-radius: ${({ theme }) => theme.radii.default};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  background-color: ${({ theme }) => theme.colors.backgroundAlt2};
`

export default function SwapModalFooter({
  trade,
  onConfirm,
  disabledConfirm,
  cashbackPool,
}: {
  trade: Trade<Currency, Currency, TradeType>
  onConfirm: () => void
  disabledConfirm: boolean
  cashbackPool: CashbackPoolResponse
}) {
  const { t } = useTranslation()
  const [showInverted, setShowInverted] = useState<boolean>(false)
  const { priceImpactWithoutFee, realizedTradeFee, tradeFee, realizedLpFee } = useMemo(
    () => computeTradePriceBreakdown(trade),
    [trade],
  )
  const severity = warningSeverity(priceImpactWithoutFee)

  return (
    <div className="flex flex-col gap-12">
      <SwapModalFooterContainer gap="8px">
        <RowBetween align="center">
          <div className="text-white text-14">{t('Price')}</div>
          <TradePrice showInverted={showInverted} setShowInverted={setShowInverted} price={trade?.executionPrice} />
        </RowBetween>
        <AdvancedSwapDetails
          trade={trade}
          realizedTradeFee={realizedTradeFee}
          cashbackPool={cashbackPool}
          priceImpactWithoutFee={priceImpactWithoutFee}
          realizedLpFee={realizedLpFee}
          tradeFee={tradeFee}
        />
      </SwapModalFooterContainer>

      <AutoRow>
        <SlButton
          variant={severity > 2 ? 'danger' : 'primary'}
          onClick={onConfirm}
          disabled={disabledConfirm}
          id="confirm-swap-or-send"
          className="w-[100%]"
        >
          {severity > 2 ? t('Swap Anyway') : t('Confirm Swap')}
        </SlButton>
      </AutoRow>
    </div>
  )
}
